<template>
  <context-display :context="context">
    <template #workarea>
      <span>Aggregate Function: <b>{{displayText}}</b></span>
    </template>
  </context-display>
</template>

<script lang="ts">
  import Vue from "vue";
  import {IAggregatable} from "~/interfaces/propertyInterfaces";
  import ContextDisplay from "../layouts/contextDisplay.vue";
  import basePropertyDisplayMixin from "../../mixins/modelProperties/basePropertyDisplayMixin";
  import {AggregateMetadata} from "~/enums/aggregateType";

  export default Vue.extend({
    components: {
      ContextDisplay,
    },
    mixins: [
      basePropertyDisplayMixin,
    ],
    props: {
      model: {
        type: Object as () => IAggregatable,
        required: true,
      },
    },
    data: function () {
      return {};
    },
    computed: {
      displayText(): string {
        if (!this.model.canAggregate) {
          if (this.showFallback) return this.cantFallback;
        } else if (this.model.aggregate_type) {
          return AggregateMetadata[this.model.aggregate_type]?.label
        } else {
          if (this.showFallback) return this.fallback;
        }
      },
    },
  });
</script>
